/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * API
 * OpenAPI spec version: 1.0.0
 */

export type GetApiListBookingDiscountsSortOrder =
    (typeof GetApiListBookingDiscountsSortOrder)[keyof typeof GetApiListBookingDiscountsSortOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetApiListBookingDiscountsSortOrder = {
    asc: 'asc',
    desc: 'desc',
} as const;
